import * as Rest from 'src/constants/rest'
import {
  Colegio,
  Comunidad,
  Orden,
  OrganoJudicial,
  PartidoJudicial,
  Provincia,
  TipoIntervencion
} from 'src/interfaces/Catalog/index'
import http from 'src/utils/Http'

export interface ListComunidadesResponse {
  results: Comunidad[]
}

export interface ListProvinciasResponse {
  results: Provincia[]
}

export interface ListPartidosJudicialesResponse {
  results: PartidoJudicial[]
}

export interface ListOrganosJudicialesResponse {
  results: OrganoJudicial[]
}

export interface ListColegiosResponse {
  results: Colegio[]
}

export async function getColegios(): Promise<ListColegiosResponse> {
  return http
    .get({
      url: Rest.COLEGIOS_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getComunidades(): Promise<ListComunidadesResponse> {
  return http
    .get({
      url: Rest.COMUNIDADES_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getProvincias(): Promise<ListPartidosJudicialesResponse> {
  return http
    .get({
      url: Rest.PROVINCIAS_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getPartidosJudiciales(): Promise<ListProvinciasResponse> {
  return http
    .get({
      url: Rest.PARTIDOS_JUDICIALES_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getOrganosJudiciales(): Promise<ListOrganosJudicialesResponse> {
  return http
    .get({
      url: Rest.ORGANOS_JUDICIALES_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function sendLegalWriting(): Promise<ListOrganosJudicialesResponse> {
  return http
    .post({
      url: Rest.LEGAL_WRITING_SEND,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getTipoVia(): Promise<any> {
  return http
    .post({
      url: Rest.TIPO_VIA,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getOrganismosExtrajudiciales(): Promise<any> {
  return http
    .get({
      url: Rest.ORGANISMOS_EXTRAJUDICIALES_LIST,
      token: true
    })
    .then(res => ({
      results: res
    }))
}

export async function getTipoResolucion(): Promise<any> {
  return http
    .get({
      url: Rest.TIPO_RESOLUCION,
      token: true
    })
    .then(res => res)
}

type TipoIntervencionProps = {
  orden: Orden | null
  organo: OrganoJudicial | null
}
export async function getTipoIntervencion({
  orden,
  organo
}: TipoIntervencionProps): Promise<TipoIntervencion[]> {
  return http.get({ url: Rest.TIPO_INTERVENCION, token: true }).then(res =>
    res?.filter((data: any) => {
      return data.funcionOrdenTipoOrgano.some((v: any) => {
        return v.organo === organo?.tipoOrgano && v.orden === orden?.orden
      })
    })
  )
}
